import { render, staticRenderFns } from "./ListBankBat.vue?vue&type=template&id=2764ee42&scoped=true"
import script from "./ListBankBat.vue?vue&type=script&lang=js"
export * from "./ListBankBat.vue?vue&type=script&lang=js"
import style0 from "./ListBankBat.vue?vue&type=style&index=0&id=2764ee42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764ee42",
  null
  
)

export default component.exports